// extracted by mini-css-extract-plugin
export default {"melodyVideo":"BK-z","isFullWidth":"CK-z","landingPageVideo":"DK-z","play":"EK-z","iframeVideo":"FK-z","playHidden":"GK-z","fullwidth":"HK-z"};